/**
 * Get a value from an nested object
 *
 * @param {Object}  object Object that we want to query from
 * @param {String} path query path for that object in form of "path.to.object"
 * @param {any} defaultValue default value to be returned if path does not exist
 *
 * @returns {Object} value if found. otherwise, return default value or undefined
 */export default(function(object,path,defaultValue){if(!path){return defaultValue;}var pathArray=path.split('.');return pathArray.reduce(function(prevPath,nextPath){var _prevPath$nextPath;return(_prevPath$nextPath=prevPath===null||prevPath===void 0?void 0:prevPath[nextPath])!==null&&_prevPath$nextPath!==void 0?_prevPath$nextPath:defaultValue;},object);});
//# sourceMappingURL=getByPath.js.map